import { render } from "./CouponEdit.vue?vue&type=template&id=1a52c6c5"
import script from "./CouponEdit.vue?vue&type=script&lang=js"
export * from "./CouponEdit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/intermagtech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__